import * as React from 'react';
export const invoiceSvg = React.forwardRef(function invoiceSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4 4.7a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 4 4.7Zm.75 2.25a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1.553 15.276A1 1 0 0 1 1 14.382V2.5A2.5 2.5 0 0 1 3.5 0h9A2.5 2.5 0 0 1 15 2.5V12a1 1 0 0 1-.4.8l-1.3.975a.5.5 0 0 1-.6 0l-1.384-1.038a.5.5 0 0 0-.62.016l-2.423 2.02a.5.5 0 0 1-.578.044l-1.86-1.116a.5.5 0 0 0-.611.075l-1.97 1.97a.5.5 0 0 1-.576.093l-1.125-.563Zm.947-1.203V2.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v9.25l-.5.375-.784-.588a2 2 0 0 0-2.48.064l-1.878 1.565-1.252-.751a2 2 0 0 0-2.443.3l-1.46 1.46-.203-.102Z',
    }),
  );
});
invoiceSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var invoice = {
  category: 'icon',
  colorable: true,
  name: 'invoice',
  svg: invoiceSvg,
};
